import { render, staticRenderFns } from "./OrderLimits.vue?vue&type=template&id=6268382e&scoped=true"
import script from "./OrderLimits.vue?vue&type=script&lang=js"
export * from "./OrderLimits.vue?vue&type=script&lang=js"
import style0 from "./OrderLimits.vue?vue&type=style&index=0&id=6268382e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6268382e",
  null
  
)

export default component.exports